// src/context/AuthContext.js - FIXED with proper login API call
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('user');
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  });
const [token, setToken] = useState(() => localStorage.getItem('authToken'));
  const [loading, setLoading] = useState(true);

  // Check if token and user exist in localStorage on mount
  useEffect(() => {
    try {
      const storedToken = localStorage.getItem('authToken');
      const storedUser = localStorage.getItem('user');
      
      if (storedToken && storedUser) {
        // Both token and user exist - user is logged in
        setToken(storedToken);
        setUser(JSON.parse(storedUser));
      } else {
        // Missing token or user - clear everything
        setToken(null);
        setUser(null);
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error checking authentication:', error);
      setToken(null);
      setUser(null);
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      setLoading(false);
    }
  }, []);

  // Login function - calls backend and saves token
  const login = async (credentials) => {
    try {
      const apiUrl = '';
      
      // Call backend login endpoint
      const response = await axios.post(`${apiUrl}/api/auth/login`, {
        identifier: credentials.identifier,
        password: credentials.password
      });

      // Extract token and user from response
      const { token: newToken, user: userData } = response.data;

      if (!newToken) {
        throw new Error('No token received from server');
      }

      // Save to state
      setToken(newToken);
      setUser(userData);

      // Save to localStorage
      localStorage.setItem('authToken', newToken);
      localStorage.setItem('user', JSON.stringify(userData));

      return { token: newToken, user: userData };
    } catch (error) {
      console.error('Login error:', error);
      
      // Clear auth on failure
      setToken(null);
      setUser(null);
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      
      throw error;
    }
  };
// Register function 
  const register = async (userData) => {
    try {
      const apiUrl = '';
      
      const response = await axios.post(`${apiUrl}/api/auth/register`, {
        username: userData.username,
        email: userData.email,
        password: userData.password
      });

      const { token: newToken, user: newUser } = response.data;

      if (!newToken) {
        throw new Error('No token received from server');
      }

      setToken(newToken);
      setUser(newUser);
      localStorage.setItem('authToken', newToken);
      localStorage.setItem('user', JSON.stringify(newUser));

      return { token: newToken, user: newUser };
    } catch (error) {
      console.error('Register error:', error);
      setToken(null);
      setUser(null);
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      throw error;
    }
  };

  // Logout function
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    register
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}